import { GrUserAdmin } from 'react-icons/gr';

export default [
  {
    label: 'Hiring managers space ',
    icon: GrUserAdmin,
    href: '/login',
  },
];
